export const FEEDBACK_LOADING = "FEEDBACK_LOADING";
export const FEEDBACK_SUCCESS = "FEEDBACK_SUCCESS";
export const FEEDBACK_FAILED = "FEEDBACK_FAILED";

export const FEEDBACK_SAVE_LOADING = "FEEDBACK_SAVE_LOADING";
export const FEEDBACK_SAVE_SUCCESS = "FEEDBACK_SAVE_SUCCESS";
export const FEEDBACK_SAVE_FAILED = "FEEDBACK_SAVE_FAILED";